// Auto generated file, do not manually modify!
// com.hotpads.notification.web.api.NotificationBrowserTrackingApiHandler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

interface SaveEventParams {
  nid: string;
  ref: string;
  type: string;
}

export const NotificationBrowserTrackingApiHandler_saveEvent_Path = '/api/notification/browser/saveEvent';

export const NotificationBrowserTrackingApiHandler_saveEvent = (getParams: SaveEventParams, client = getClient()) => {
  return httpApiRequest<SaveEventParams, never, void>(
    {
      getParams: getParams,
      endpoint: NotificationBrowserTrackingApiHandler_saveEvent_Path,
      method: 'GET',
      contextPath: '/notification',
    },
    client,
  );
};
